import { EquipmentExp } from '@components/game/gameEndedModal/EquipmentExp';
import { Glitch } from '@components/helpers/Glitch';
import { useGameStore, useAppStore } from '@stores';
import { getLootdropData } from '@helpers/drops';
import { useTranslation } from 'react-i18next';
import { getItemColor } from '@helpers/items';
import { Modal } from '@components/ui/Modal';
import { toast } from 'react-toastify';

export function GameEndedModal() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Game.GameEnded' });
  const { gameEndedState, setGameEndedState } = useGameStore();
  const { userData, refetch, setTab } = useAppStore();

  const equipmentExp = gameEndedState?.equipmentExp;
  const success = gameEndedState?.success;
  const drops = gameEndedState?.drops;
  const isOpen = !!gameEndedState;

  const titleClass = success ? 'bg-primary text-black' : 'bg-health';
  const sortedDrops = (drops ?? [])
    .sort((a, b) => b.amount - a.amount)
    .map(drop => getLootdropData(drop))
    .filter(drop => !!drop);

  const close = async () => {
    setGameEndedState(null);
    await refetch();

    const hasCompletedMission = userData.quests
      .some(q => q.progress >= q.amount && !q.collected);
    if (!hasCompletedMission) return;

    toast(t('questReady'), {
      type: 'success',
      onClick: () => setTab('hub')
    });
  };

  const itemClass = (index: number) => {
    if (!drops) return '';

    const isLastRow = index >= drops.length - (drops.length % 2 === 0 ? 2 : 1);
    const hasRightBorder = index % 2 === 0 || (drops.length % 2 !== 0 && index === drops.length - 1);

    return `border-0 ${hasRightBorder && 'border-r-1'} ${!isLastRow && 'border-b-1'}`;
  };

  return (
    <Modal onRequestClose={close} title={t('title')} isOpen={isOpen}>
      <div className="modal-scroll">
        <p className={`${titleClass} text-center p-2 py-4 text-2xl font-bold uppercase`}>
          <Glitch>
            {t(success ? 'success' : 'failed')}
          </Glitch>
        </p>

        {!success && (
          <p className="text-center font-bold border-b border-secondary bg-health text-sm px-2 pb-3">
            {t('upgradeInfo')}
          </p>
        )}

        <div className="flex-1 overflow-y-auto">
          <EquipmentExp xp={equipmentExp ?? 0} />

          <div className="grid grid-cols-2">
            {sortedDrops.map((drop, i) => (
              <div
                className={`${itemClass(i)} border border-secondary py-1`}
                key={`${drop.type}-${drop.id}`}
              >
                <p className="text-mono text-sm text-center">{drop.amount}</p>
                <img
                  src={`/assets/items/${drop.dropImage}.avif`}
                  className="h-12 mx-auto p-2"
                  alt={drop.name}
                />
                <p className={`${getItemColor(drop)} text-center text-sm`}>
                  {drop.name}
                </p>
              </div>
            ))}
          </div>
        </div>

        <button className="btn btn-primary border-x-0 border-b-0" onClick={close}>
          {t('close')}
        </button>
      </div>
    </Modal>
  );
}